export default __webpack_public_path__ + "static/media/celebrate.4da82500.png";